import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'generateClass' })
export class GenerateClassPipe implements PipeTransform {
  transform(value: any) {
    const removalCharacters = value
      .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '')
      .replace(/\s\s+/g, ' ');
    return removalCharacters.replace(/ /g, '-');
  }
}
